import Vue from 'vue';

export default {
    state:{
      sesion:{}
    },
    mutations: {},
    actions: { 
      Escuchar_Sesion(context){
        
      },
    },
    getters: {}
}


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/sesion.js